import React from "react";
import { Box, Button, CardContent, Stack, Typography } from "@mui/material";
import HoverCard from "./HoverCard";
import IconTile from "./IconTile";

interface ActionCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  actionLabel: string;
  onAction: () => void;
  actionIcon?: React.ReactNode;
  disabled?: boolean;
  color?: "primary" | "secondary";
}

const ActionCard: React.FC<ActionCardProps> = ({
  icon, title, description, actionLabel, onAction, actionIcon, disabled, color = "primary"
}) => (
  <HoverCard sx={{ height: "100%", opacity: disabled ? 0.6 : 1 }}>
    <CardContent sx={{ p: "24px", height: "100%" }}>
      <Stack sx={{ height: "100%" }} spacing={2}>
        <IconTile color={color}>{icon}</IconTile>
        <Box sx={{ flex: 1 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>{title}</Typography>
          <Typography variant="body2" color="text.secondary">{description}</Typography>
        </Box>
        <Button variant="contained" startIcon={actionIcon} onClick={onAction} disabled={disabled} sx={{ alignSelf: "flex-start" }}>
          {actionLabel}
        </Button>
      </Stack>
    </CardContent>
  </HoverCard>
);

export default ActionCard;
